// Webpack Imports
import * as bootstrap from "bootstrap";
import "./custom";

let refresh_timer = "";

jQuery(document).ready(function () {});
